/* eslint-disable */
import { fetchAllChats, getMemberDetails } from "../services";
import { initChats, updateChat, updateParticipantActivity, updateParticipantsActivity } from "../store/slices/chatsSlice";
import { initProfile, resetProfile } from "../store/slices/profileInfo";
import { resetStudentProfile } from "../store/slices/studentsInfo";
import { resetAuth, setUserAuthStatus } from "../store/slices/userAuthSlice";
import { store } from "../store/store";
import { Chat, FilterInfo, FilterSelected, ListItem, Participant, TriggerObject } from "../types/types";
import { COMPONENTS } from "./enums";
import Socket from "./socket";
import { Chat as ChatType } from "../types/types";


const dispatch = store.dispatch;
let token = localStorage.getItem("_auth_token");
let role = localStorage.getItem("role");

 const getMember = async() =>{
  const response = await getMemberDetails();
  if(response.success){
    dispatch(
      initProfile({
        requestStatus: "initiated",
        responseStatus: "recieved",
        haveAnIssue: false,
        issue: "",
        data: response.data,
      })
    );
    return {
      _id: response.data._id,
      firstName: response.data.firstName,
      lastName: response.data.lastName,
      displayPicSrc: response.data.displayPicSrc
        ? response.data.displayPicSrc
        : "https://res.cloudinary.com/dffdp7skh/image/upload/v1706879929/nvitahnrlhvmtcizpthx.png",
      email: "",
      userType: "student",
    };
}
 }
export const checkUser = async () => {
    token = localStorage.getItem("_auth_token");
    role = localStorage.getItem("role");
    dispatch(
      setUserAuthStatus({
        isAuthorized: token ? true : false,
        isRegistered: token ? true : false,
        role: token ? "team" : "anonymous",
      })
    );
    if (token) {
      Socket.removeListener("trigger", triggerRoot);
      Socket.on("trigger", triggerRoot)
      getMember().then((currentuser: any) => {
        Socket.emit("join", currentuser);
        fetchChats().then((allchats) => {
          if (currentuser) {
            let friends: any = getFriends(allchats, currentuser._id);
            // console.log(currentuser,friends)
            let triggerObj: TriggerObject = {
              action: "ping",
              sender: currentuser,
              recievers: friends,
              data: { respond: false, status: "online" },
            };
            Socket.emit("trigger", triggerObj);
          }
        });
      });
  }else{

  }
};
  const fetchChats = async () => {
    let allchats = [];
    try {
      const response = await fetchAllChats();
  
      if (response) {
        allchats = response.data.data.map((chat: ChatType) => ({
          ...chat,
          participants: chat.participants.map((participant) => ({
            ...participant,
            activity: "offline",
          })),
        }));
        dispatch(
          initChats({
            requestStatus: "initiated",
            responseStatus: "recieved",
            haveAnIssue: false,
            issue: "",
            data: allchats,
          })
        );
      }
      return allchats;
    } catch (error) {}
  };
  
  const triggerRoot=(triggerObj:TriggerObject)=>{
    console.log(JSON.stringify(triggerObj,null,2))
    switch(triggerObj.action){
        case "activityList":
            dispatch(updateParticipantsActivity(triggerObj.data))
            break
        case "ping":
            dispatch(updateParticipantActivity({...triggerObj.sender,role:"",activity:triggerObj.data.status}))
            break;
  
        case "typing":
            dispatch(updateParticipantActivity({...triggerObj.sender,role:"",activity:triggerObj.data==="start"?"typing":"inchat"}))
            break;
        
        case "send":
            //console.log("chat send trigger",triggerObj.data.chat)
            dispatch(updateChat(triggerObj.data.chat))
            break;
  
        case "seen":
            dispatch(updateChat(triggerObj.data));
            break;
    }
  }
  
  export const getFriends = (chats: ChatType[], currentUserId: string) => {
    let participants: Participant[] = [];
    let allusers: Participant[] = chats.reduce(
      (accumulator, currentValue) => [
        ...accumulator,
        ...currentValue.participants,
      ],
      participants
    );
    return Array.from(new Set(allusers.map((a) => a._id)))
      .map((_id) => {
        return allusers.find((a) => a._id === _id);
      })
      .filter((user) => user?._id !== currentUserId);
  };
  
  
  export const getChatType = (chat: Chat) => {
    return chat.participants.find(
      (participant) => participant.userType === "student"
    )
      ? "community"
      : "advisors";
  };
  
  export const getExploreUrl=(type:string,data:any)=>{
    const encodedUrl = window.location.search.slice(1); 
    let decodedUrl = "";
    try {
      decodedUrl = window.atob(encodedUrl);
    } catch (error) {
      console.error("Error decoding URL", error);
      decodedUrl = ""; 
    }
    const searchParams = new URLSearchParams(decodedUrl);
    let filterUrl=searchParams.get("FilterData");
    let activeUrl=searchParams.get("activeTab")
    let FilterData= (filterUrl!==undefined && filterUrl!==null)? JSON.parse(filterUrl) : [];
    let activeTab=activeUrl?JSON.parse(activeUrl):"courses"
    let url=`activeTab=${(type==="activeTab"?JSON.stringify(data):JSON.stringify(activeTab))}&FilterData=${type==="filterData"?(encodeURIComponent(JSON.stringify(data))):encodeURIComponent(JSON.stringify(FilterData))}`
    const subDisciUrl = (`/explore?${window.btoa(url)}`);
    return subDisciUrl
  }
export const logOut = () =>{
    resetAuth();
    resetProfile();
    resetStudentProfile();
  window.location.href = "/";
}  

export const  formatDate = (dateString: string, day: boolean): string =>{
  const options: Intl.DateTimeFormatOptions = day
    ? { year: "numeric", month: "long" }
    : { year: "numeric", month: "long", day: "numeric" };
  return new Date(dateString).toLocaleDateString(undefined, options);
}

export const setWordCase = (word: string | undefined) => {
  if (word && word.length !== 0) {
    let lowercase = word.toLowerCase();
    return lowercase[0].toUpperCase() + lowercase.substring(1);
  } else {
    return "";
  }
};

export const getComponent = (id: string) => {
  let index = COMPONENTS.findIndex((item) => item.name === id);
  // console.log(id,"component")
  return COMPONENTS[index].component;
};

export const maskInput = (input: string | undefined, type: "email" | "phone"): string => {
  if (!input) return "";

  if (type === "email") {
    const [username, domain] = input.split("@");
    if (username.length <= 2) return `${username}@${domain}`;

    const maskedUsername = username[0] + username[1] + "*".repeat(5);
    return `${maskedUsername}@${domain}`;
  }

  if (type === "phone") {
    const lastFourDigits = input.slice(-4);
    const maskedSection = "*".repeat(input.length - 4);
    return `${maskedSection}${lastFourDigits}`;
  }

  return input;
};

export const normalizeType = (type: string): string => {
  const words = type?.replace(/([a-z])([A-Z])/g, "$1 $2")?.split(" ")??[];
  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const FilterHandler=(data: {
  data: ListItem;
  filterInfo: FilterInfo;
  filter: FilterSelected;
}) => {
  console.log(data,"multi")
  let currenFilterdata = data.filter;
  let filterdata: FilterSelected = { ...data.filter };
  if (data.filterInfo?.selectedType === "single") {
    if (currenFilterdata?.data.length ===0) {
      filterdata.data.push(data.data);
    } else {
      if(currenFilterdata?.data[0].name===data.data.name)
      {
        filterdata.data = []
      }
      else
      {
        filterdata.data = [data.data]
      }
    }
  }
  if (data.filterInfo?.selectedType === "multi") {
    currenFilterdata = data.filter
    if (currenFilterdata?.data.find((item) => item.name === data.data.name)) {

      filterdata.data = filterdata.data.filter((item) => item.name !== data.data.name);
    } else {
      filterdata.data = [...filterdata.data, data.data];
    }
  }
  return filterdata;
};

export const FiltersHandler=(data: FilterSelected,appliedFilters:FilterSelected[]) => {
  let filterdata: FilterSelected = data;
  // let allFilters:FilterSelected[] = [];
  let filterindex = appliedFilters.findIndex(
    (filter) => filter.type === data.type
  );
  if (filterdata.data.length !== 0) {
    if (filterindex === -1) {
      appliedFilters = [...appliedFilters, filterdata];
    } else {
      let temp = [...appliedFilters];
      temp.splice(filterindex, 1, filterdata);
      appliedFilters= temp;
    }
  } else {
    appliedFilters = [
      ...appliedFilters.filter((filter) => filter.type !== data.type),
    ];
    
  }
  return appliedFilters;
};
